import ReporteStockCrud from './ReporteStockCrud'
export {ReporteStockCrud}
export default ReporteStockCrud
